export const STORAGE_KEY = "m3admin";

export const message = {
  modfiy: "수정하시겠습니까?",
  save: "저장하시겠습니까?",
  confirmMsg: "완료되었습니다.",
}

export const dateFormat = "YYYY-MM-DD";